import React from 'react';

import ProgressCircle from '../../progress-circle/progress-circle';

interface Props {
    onlineStudentsCount: number;
    curAnswersCount?: number;
}

export const QuizChildrenCountCircle = (props: Props) => {
    const { onlineStudentsCount, curAnswersCount } = props;

    return (
        <div className="quiz-teacher__children-count-circle">
            <ProgressCircle
                {...{
                    max: onlineStudentsCount,
                    value: curAnswersCount || 0,
                    strokeWidth: 8,
                    size: 192,
                }}
            />
        </div>
    );
};
